import { render } from "./labApproveReject.vue?vue&type=template&id=05f79e37&scoped=true"
import script from "./labApproveReject.js?vue&type=script&lang=js"
export * from "./labApproveReject.js?vue&type=script&lang=js"

import "./labApproveReject.vue?vue&type=style&index=0&id=05f79e37&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f79e37"]])

export default __exports__